/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import maleAvatar from "../../assets/images/Male-Avatar.png";
import * as actions from "../../store/actions";
import {Loader} from "react-overlay-loader";
import computerIcon from "../../assets/images/computer-icon-hover.png";
import alertsIcon from '../../assets/images/alerts-icon.png';

class Installation extends Component {
    state = {
        tags: this.props.tags || [],
        addTag: false,
        editTag: false,
        showDelete: false,
        editedTag: null,
        deletedTag: null,
        editedTagId: null,
        apiToken: null,
        resetApiToken: false,
        awsRegions: [],
        terraformScripts: this.props.terraformScripts,
        cfPath: this.props.installations.cfPaths ? this.props.installations.cfPaths['IO'] : null,
    };

    componentWillMount() {
        this.setState({apiToken: null, resetApiToken: true});
        this.props.onFetchInstallation(this.props.token);
    }

    componentDidMount() {
        let setSelectState = (values) => {
            let regions = this.state.awsRegions
            this.setState( {awsRegions: regions.concat(values)})
        }
        let setDeselectState = (values) => {
            let regions = this.state.awsRegions
            this.setState({
                awsRegions: regions.filter(t => t !== values[0])
            })
        }
        let afterSelectFunc = function (values) {
            setSelectState(values)
        }
        let afterDelectFunc = function (values) {
            setDeselectState(values)
        }
        window.$(function () {
            window.jcf.replaceAll();
            window.$('[data-toggle="offcanvas"]').on('click', function () {
                window.$('.offcanvas-collapse').toggleClass('open')
            })

            window.$("#multi-select").multiSelect({
                selectableHeader: "<div id='availRegionHeader'>Available Regions</div>",
                selectionHeader: "<div id='selectRegionHeader'>Selected Regions</div>",
                afterSelect: afterSelectFunc,
                afterDeselect: afterDelectFunc,
            });
            window.$('#availRegionHeader').css({textAlign: "center", fontWeight: "bold"})
            window.$('#selectRegionHeader').css({textAlign: "center", fontWeight: "bold"})
        })
    }

    UNSAFE_componentWillReceiveProps(props) {
        if (this.state.resetApiToken) {
            this.setState({
                tags: props.tags ? props.tags : [],
            });
        } else {
            this.setState({
                tags: props.tags ? props.tags : [],
                apiToken: props.apiToken,
            });
        }
        this.setState({
            cfPath: props.installations.cfPaths ? props.installations.cfPaths['IO']: null,
        })

    }

    isReadOnly = () => {
        if (this.props.permissions === null || this.props.permissions === undefined) {
            return false;
        }
        if (this.props.permissions.policies === null || this.props.permissions.policies === undefined) {
            return false;
        }
        //for now we only care about READONLY for all features
        if (this.props.permissions.policies.length === 0) {
            return false;
        }
        let p = this.props.permissions.policies[0];
        if (p.role === "ReadOnly" && p.feature === "All") {
            return true;
        }

        return false;
    };

    redirectToDashboard = (event) => {
        event.preventDefault();
        this.props.history.push("/dashboard")
    };

    redirectToGcpDashboard = (event) => {
        event.preventDefault();
        this.props.history.push("/gcpDashboard")
    };

    redirectToXogroups = (event) => {
        event.preventDefault();
        this.props.history.push("/xogroups")
    };

    redirectToScheduler = (e) => {
        e.preventDefault();
        this.props.history.push("/schedulers")
    };

    redirectToAlerts = (e) => {
        e.preventDefault();
        this.props.history.push("/alerts")
    }

    redirectToBudget = (e) => {
        e.preventDefault();
        this.props.history.push("/budgets")
    };

    handleEditTagName = e => {
        this.setState({editedTag: {...this.state.editedTag, name: e.target.value}})
    };

    handleEditTagValue = e => {
        this.setState({editedTag: {...this.state.editedTag, value: e.target.value}})
    };
    handleEditTag = (e, id) => {
        e.preventDefault();
        this.setState({editTag: true, editedTag: this.state.tags[id], editedTagId: id})
    };

    handleDeleteTag = (e, id) => {
        e.preventDefault();
        this.setState({showDelete: true, deletedTag: id})
    };

    handleDelete = e => {
        e.preventDefault();
        if (this.state.deletedTag !== null) {
            let tags = [...this.state.tags.slice(0, this.state.deletedTag), ...this.state.tags.slice(this.state.deletedTag + 1)];
            this.setState({tags: tags, showDelete: false, deletedTag: null});
            this.props.onUpdateTag(this.props.token, tags);
        }
    };

    handleAddTagSubmit = (e) => {
        e.preventDefault()
        let tags = this.state.tags.concat(this.state.editedTag);
        this.setState({tags: tags, addTag: false, editedTag: null});
        this.props.onUpdateTag(this.props.token, tags)
    };

    handleEditTagSubmit = (e) => {
        e.preventDefault();

        let tags = [...this.state.tags.slice(0, this.state.editedTagId), this.state.editedTag, ...this.state.tags.slice(this.state.editedTagId + 1)];
        this.setState({tags: tags, editTag: false, editedTag: null, editedTagId: null});
        this.props.onUpdateTag(this.props.token, tags)
    };

    handleCloudformationLink = (e) => {
        e.preventDefault()
        this.setState({cfPath: this.props.installations.cfPaths[e.target.value]})
    }

    handleRegenCf = (e) => {
        e.preventDefault();
        this.props.onRegenCf(this.props.token)
    };

    toggleAddTag = () => {
        this.setState({
            addTag: !this.state.addTag
        });
    };

    toggleEditTag = () => {
        this.setState({
            editTag: !this.state.editTag
        });
    };
    toggleShowDelete = () => {
        this.setState({
            showDelete: !this.state.showDelete
        });
    };

    handleCancelDelete = () => {
        this.setState({showDelete: false, deletedUser: null, deletedAccount: null})
    };

    redirectToSettings = (event) => {
        event.preventDefault();
        this.props.history.push("/accountSettings")
    };

    handleLogout = () => {
        // this.setState({logoutClicked: true});
        this.props.onLogout(this.props.token)
    };

    openInNewTab = (e, url) => {
        e.preventDefault();
        let win = window.open(url, '_blank');
        win.focus();
    };

    showApiToken = (e) => {
        e.preventDefault();
        this.setState({resetApiToken: false});
        this.props.onShowApiToken(this.props.token);
    };

    handleRevokeApiToken = (e) => {
        e.preventDefault();

        this.setState({apiToken: null});
        this.props.onRegenCf(this.props.token);
    };

    handleAWSInstallationRegions = (e) => {
        this.setState({awsRegions: [...e.target.options].filter(o => o.selected).map(o => o.value)})
    }

    showTerraform = (e) => {
        e.preventDefault();
        this.props.onShowTerraformScripts(this.props.token, this.state.awsRegions)
    }

    render() {
        return (
            <div>
                <div className="wrapper">
                    <Loader fullPage={true} loading={this.props.loading}/>
                    <div className="navbar navbar-dark bg-dark d-block d-md-none mob-nav fixed-top">
                        <button className="navbar-toggler pull-right" type="button" data-toggle="offcanvas"><span
                            className="navbar-toggler-icon"></span></button>
                        <div className="nav-item dropdown logo pull-left"><a className="dropdown-toggle text-white"
                                                                             href="http://example.com" id="dropdown10"
                                                                             data-toggle="dropdown" aria-haspopup="true"
                                                                             aria-expanded="false">
                            <div className="company-logo">
                                <div className="inner-logo rounded-circle img-thumbnail"><img src={maleAvatar}
                                                                                              alt="" title=""/></div>
                            </div>
                            {this.props.company}</a>
                            <div className="dropdown-menu" aria-labelledby="dropdown10">
                                <a className="dropdown-item" href="#">{this.props.company}</a>
                                <a className="dropdown-item" href="#" onClick={this.handleLogout}>Logout</a></div>
                        </div>
                    </div>
                    <div className="sidebar offcanvas-collapse">
                        <div className="sidebar-wrapper">
                            <div className="dropdown logo d-none d-md-block"><a href="/"
                                                                                className="simple-text dropdown-toggle"
                                                                                data-toggle="collapse"
                                                                                data-target="#dropdown11">
                                <div className="company-logo">
                                    <div className="inner-logo rounded-circle img-thumbnail"><img
                                        src={maleAvatar} alt="" title=""/></div>
                                </div>
                                {this.props.company} </a>
                                <div className="dropdown-menu collapse" id="dropdown11">
                                    <a className="dropdown-item" href="#">{this.props.company}</a>
                                    <a className="dropdown-item" href="#" onClick={this.handleLogout}>Logout</a>
                                </div>
                            </div>
                            <ul className="nav">
                                {
                                    this.props.gcpOnly ? null :
                                        (<li><a href="#" onClick={this.redirectToDashboard}> <i className="fa fa-bar-chart"></i>
                                            <p>AWS Dashboard</p>
                                        </a></li>)
                                }
                                {
                                    this.props.hasGcp ?
                                        (
                                            <li><a href="#" onClick={this.redirectToGcpDashboard}> <i className="fa fa-bar-chart"></i>
                                                <p>GCP Dashboard</p>
                                            </a></li>
                                        ) : null
                                }

                                <li><a href="#" onClick={this.redirectToXogroups}> <i className="com-icon"><img
                                    src={computerIcon} alt="" title=""/></i>
                                    <p>Xogroups</p>
                                </a></li>
                                <li><a href="#" onClick={this.redirectToBudget}> <i className="fa fa-dollar"></i>
                                    <p>Budgets</p>
                                </a></li>
                                <li><a href="#" onClick={this.redirectToScheduler}> <i className="fa fa-calendar"></i>
                                    <p>Schedules</p>
                                </a></li>
                                <li><a href="#" onClick={this.redirectToAlerts}> <i className="com-icon"><img
                                    src={alertsIcon} alt="" title="" width="25"/></i>
                                    <p>Alerts</p>
                                </a></li>
                                <li className="active"><a href="#"> <i className="fa fa-wrench"></i>
                                    <p>Installation</p>
                                </a></li>
                                <li><a href="#" onClick={this.redirectToSettings}> <i className="fa fa-gear"></i>
                                    <p>Settings</p>
                                </a></li>
                            </ul>
                        </div>
                    </div>

                    <div className="main-panel">
                        <div className="content">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="card">
                                            <div className="content">
                                                <div className="header">
                                                    <h4 className="title mb-3">CloudFormation</h4>
                                                </div>
                                                <div className="row justify-content-md-center">
                                                    <div className="col-md-9 text-center">
                                                        {/*<h2><strong>Dummy text</strong></h2>*/}
                                                        <p>Select the CloudFormation template you wish to install below and click on the Launch Stack button to get started.</p>
                                                        <div className="mt-2 multi-select" style={{paddingBottom: "20px"}}>
                                                        <select defaultValue="IO" onChange={e => this.handleCloudformationLink(e)}>
                                                            <option value="IO">
                                                                Xosphere Instance Orchestrator - Orchestration Engine
                                                            </option>
                                                            <option value="AWS_ORG">
                                                                Xosphere Instance Orchestrator - AWS Organization Management Account
                                                            </option>
                                                            <option value="XO_MGMT">
                                                                Xosphere Instance Orchestrator - Xosphere Management Account
                                                            </option>
                                                            <option value="ORG_INV">
                                                                Xosphere Instance Orchestrator - Organization Inventory Collector
                                                            </option>
                                                            <option value="ORG_RI_SUB">
                                                                Xosphere Instance Orchestrator - Savings Instrument Purchasing Account
                                                            </option>
                                                        </select>
                                                        </div>
                                                        <div className="row justify-content-md-center">
                                                            <div className="col-md-9 text-center">
                                                        <a href="#" onClick={(e) => {
                                                            if (this.isReadOnly()) {
                                                                return false;
                                                            } else {
                                                                this.openInNewTab(e, this.state.cfPath)
                                                            }
                                                        }}
                                                           className="btn btn-lg btn-warning">Launch Stack <i
                                                            className="fa fa-chevron-circle-right"></i></a></div>
                                                        </div></div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="card">
                                            <div className="content">
                                                <div className="header">
                                                    <h4 className="title mb-3">Terraform</h4>
                                                </div>
                                                <div className="row justify-content-md-center">
                                                    <div className="mt-2 multi-select" style={{paddingBottom: "20px"}}>
                                                        <select id="multi-select" multiple="multiple"
                                                                placeholder="Select AWS regions"
                                                                onChange={e => this.handleAWSInstallationRegions(e)}>
                                                            <option value='us-east-2'>US East (Ohio)</option>
                                                            <option value='us-east-1'>US East (N. Virginia)</option>
                                                            <option value='us-west-1'>US West (N. California)</option>
                                                            <option value='us-west-2'>US West (Oregon)</option>
                                                            <option value='af-south-1'>Africa (Cape Town)</option>
                                                            <option value='ap-east-1'>Asia Pacific (Hong Kong)</option>
                                                            <option value='ap-southeast-3'>Asia Pacific (Jakarta)</option>
                                                            <option value='ap-south-1'>Asia Pacific (Mumbai)</option>
                                                            <option value='ap-northeast-3'>Asia Pacific (Osaka)</option>
                                                            <option value='ap-northeast-2'>Asia Pacific (Seoul)</option>
                                                            <option value='ap-southeast-1'>Asia Pacific (Singapore)</option>
                                                            <option value='ap-southeast-2'>Asia Pacific (Sydney)</option>
                                                            <option value='ap-northeast-1'>Asia Pacific (Tokyo)</option>
                                                            <option value='ca-central-1'>Canada (Central)</option>
                                                            <option value='eu-central-1'>EU (Frankfurt)</option>
                                                            <option value='eu-west-1'>EU (Ireland)</option>
                                                            <option value='eu-west-2'>EU (London)</option>
                                                            <option value='eu-south-1'>EU (Milan)</option>
                                                            <option value='eu-west-3'>EU (Paris)</option>
                                                            <option value='eu-north-1'>EU (Stockholm)</option>
                                                            <option value='me-south-1'>Middle East (Bahrain)</option>
                                                            <option value='sa-east-1'>South America (São Paulo)</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="row justify-content-md-center">
                                                    <div className="col-md-9 text-center">
                                                            <a href="#" onClick={(e) => this.showTerraform(e)}
                                                               className="btn btn-lg btn-warning">Show Script <i
                                                                className="fa fa-chevron-circle-right"></i></a>
                                                    </div>
                                                </div>
                                                <div className="row justify-content-md-center">
                                                    <div className="col-md-9" data-prismjs-copy-timeout="500">
                                                        {this.props.terraformScripts !== null ? <pre className="language-hcl"><code className="language-hcl"  data-prismjs-copy="Copy">{this.props.terraformScripts}</code></pre> : null}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>


                                        <div className="card">
                                            <div className="content">
                                                <div className="header">
                                                    <h4 className="title mb-3">User Guide</h4>
                                                </div>
                                                <div className="row justify-content-md-center">
                                                    <div className="col-md-9 text-center">
                                                        <p>For more information about installing or configuring Xosphere
                                                            Instance Orchestrator please refer to the User Guide.</p>
                                                        <a href="#"
                                                           onClick={(e) => this.openInNewTab(e, "https://www.xosphere.io/downloads/xosphere-user-guide.pdf")}
                                                           className="btn btn-lg btn-warning">Download <i
                                                            className="fa fa-chevron-circle-right"></i></a></div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="card">
                                            <div className="content">
                                                <div className="header">
                                                    <div className="row">
                                                        <div className="col-6">
                                                            <h4 className="title mt-2 mb-3">API Token</h4>
                                                        </div>
                                                        <div className="col-6 text-right">
                                                            {this.state.apiToken !== null && !this.isReadOnly() ?
                                                                <button type="button" className="btn btn-secondary"
                                                                        onClick={e => this.handleRevokeApiToken(e)}>Revoke
                                                                    API Token
                                                                </button> : null
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row justify-content-md-center">
                                                    <div className="col-md-9 text-center">

                                                        {
                                                            this.state.apiToken !== null ? this.state.apiToken :
                                                                <a href="#" onClick={(e) => this.showApiToken(e)}
                                                                   className="btn btn-lg btn-warning">Show <i
                                                                    className="fa fa-chevron-circle-right"></i></a>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {
                    this.props.terraformScripts ?
                        <div>
                            <script src="https://cdnjs.cloudflare.com/ajax/libs/prism/1.23.0/prism.min.js"
                                    integrity="sha512-YBk7HhgDZvBxmtOfUdvX0z8IH2d10Hp3aEygaMNhtF8fSOvBZ16D/1bXZTJV6ndk/L/DlXxYStP8jrF77v2MIg=="
                                    crossOrigin="anonymous"></script>
                            <script
                                src="https://cdnjs.cloudflare.com/ajax/libs/prism/1.23.0/plugins/autoloader/prism-autoloader.min.js"
                                integrity="sha512-zc7WDnCM3aom2EziyDIRAtQg1mVXLdILE09Bo+aE1xk0AM2c2cVLfSW9NrxE5tKTX44WBY0Z2HClZ05ur9vB6A=="
                                crossOrigin="anonymous"></script>
                        <script>Prism.plugins.autoloader.languages_path = 'https://cdnjs.cloudflare.com/ajax/libs/prism/1.23.0/components/'</script></div>: null
                }
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        token: state.settings.token || state.login.token,
        loading: state.installation.loading,
        error: state.installation.error,
        company: state.login.company,
        hasGcp: state.login.hasGcp,
        gcpOnly: state.login.gcpOnly,
        installations: state.installation.installations,
        tags: state.installation.tags,
        apiToken: state.installation.apiToken,
        permissions: state.login.permissions,
        terraformScripts: state.installation.terraformScripts,
    }
};

const mapDispatchToProps = dispatch => {
    return {
        onFetchInstallation: (token) => dispatch(actions.fetchInstallation(token)),
        onUpdateTag: (token, tags) => dispatch(actions.editTag(token, tags)),
        onRegenCf: (token) => dispatch(actions.regenCf(token)),
        onLogout: (token) => dispatch(actions.logout(token)),
        onShowApiToken: (token) => dispatch(actions.showApiToken(token)),
        onShowTerraformScripts: (token, awsRegions) => dispatch(actions.showTerraformScripts(token, awsRegions)),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Installation)

